// Web, iOS and Android never load the macOS project bridge.
import { create } from 'zustand';
import { AppState } from 'react-native';
import { waitForRemoteHandoff } from './remoteHandoffWait';
export const useLocalProjectStore = create(() => ({}));
export async function prepareLocalProjectLaunch() { return null; }
export async function releaseLocalProjectLaunch() {}
export async function withLocalProjectHandoff(send) {
  const out = await send({});
  if (out?.routing?.action === 'project_required') throw new Error('Open Gab AI on the connected Mac to start this task in the same project folder.');
  return waitForRemoteHandoff(send, out, { current: () => AppState.currentState !== 'background' });
}
export function startLocalProjectWorker() { return () => {}; }
